var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValuePropositionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4064 15.6666L42.2498 11.5833L46.3331 9.73996C47.2431 9.31996 47.2431 8.03663 46.3331 7.61663L42.2498 5.7733L40.4064 1.66663C39.9864 0.756631 38.7031 0.756631 38.2831 1.66663L36.4398 5.74996L32.3331 7.5933C31.4231 8.0133 31.4231 9.29663 32.3331 9.71663L36.4164 11.56L38.2598 15.6666C38.6798 16.5766 39.9864 16.5766 40.4064 15.6666ZM21.8331 19.1666L18.1231 11C17.3064 9.17996 14.6931 9.17996 13.8764 11L10.1664 19.1666L1.99977 22.8766C0.179766 23.7166 0.179766 26.3066 1.99977 27.1233L10.1664 30.8333L13.8764 39C14.7164 40.82 17.3064 40.82 18.1231 39L21.8331 30.8333L29.9998 27.1233C31.8198 26.2833 31.8198 23.6933 29.9998 22.8766L21.8331 19.1666ZM38.2598 34.3333L36.4164 38.4166L32.3331 40.26C31.4231 40.68 31.4231 41.9633 32.3331 42.3833L36.4164 44.2266L38.2598 48.3333C38.6798 49.2433 39.9631 49.2433 40.3831 48.3333L42.2264 44.25L46.3331 42.4066C47.2431 41.9866 47.2431 40.7033 46.3331 40.2833L42.2498 38.44L40.4064 34.3333C39.9864 33.4233 38.6798 33.4233 38.2598 34.3333Z",
    fill: "#007ECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuePropositionIcon);
export default __webpack_public_path__ + "static/media/ValuePropositionIcon.fa2ef0f421c0c776a39e0f68e3a8eaa9.svg";
export { ForwardRef as ReactComponent };